/**
 * Frontend Key: {Backend Property Name, Response Property Name, View Translate}
 * They appear in the table from left to right using Object.keys, so the order is important!
 * */
export const PRICING_FEATURE_PROPERTIES = {
  name: {
    backendName: "DisplayName",
    responseKey: "displayName",
    translate: "Name",
  },
  sharedFeatureName: {
    backendName: "RawName",
    responseKey: "staticName",
    translate: "RawName" // "SharedFeatureName",
  },
  description: {
    backendName: "Description",
    responseKey: "fd_Description",
    translate: "Description",
  },
  subDescription: {
    backendName: "SubDescription",
    responseKey: "subDescription",
    translate: "SubDescription",
  },
  sku: {
    backendName: "Sku",
    responseKey: "sku",
    translate: "SKU",
  },
  model: {
    backendName: "Model",
    responseKey: "model",
    translate: "Model",
  },
  thumbnail: {
    backendName: "ImageKey",
    responseKey: "imageKey",
    translate: "Thumbnail",
  },
  price: {
    backendName: "Cost",
    responseKey: "cost",
    translate: "Retail Price",
  },
  cost: {
    backendName: "Price", // they are swapped, retail price prop is Cost
    responseKey: "price",
    translate: "Cost",
  },
  fabricatorCost: {
    backendName: "FabricatorCost",
    responseKey: "fabricatorCost",
    translate: "Discount Price",
  },
  units: {
    backendName: "Unit",
    responseKey: "fd_Unit",
    translate: "Units",
  },
  unlocked: {
    backendName: "Unlocked",
    responseKey: "unlocked",
    translate: "Unlocked",
  },
  metaData: {
    backendName: "MetaData",
    responseKey: "fd_MetaData",
    translate: "MetaData",
  },
};

export const PRICING_FEATURE_PROPERTIES_ARRAY = [
  "index",
  "checkbox",
  ...Object.keys(PRICING_FEATURE_PROPERTIES),
];

export const ALWAYS_REQUEST_PROPERTIES = ["FeatureDefinition_id", "Catalog_Id"];

// "Cost","FeatureDefinition_id","Costplus","BaseQuantity","MaxQuantity","ComparisonType","ComparisonFor",
//   "ComplexLogic","ShowCostInFrontEnd","FabricatorCost","FabricatorCostplus","FabricatorBaseQuantity",
//   "FabricatorMaxQuantity","FabricatorComparisonType","FabricatorComparisonFor","FabricatorComplexLogic",
//   "DisplayName","HideUnitLabel","ProductNotForSale","EmployeesOnly","HideQuantity","DefaultQuantity",
//   "GalleryEnabled","Sku","Model","Unlocked","SubDescription","AutoAddToCart","NotTaxable","UseStonePricing",
//   "IsBundle","Height","Width","Length","DimensionMeasurements","Weight","WeightMeasurement","ShippingCost",
//   "ShippingTime","ShippingName","ShippingMetrics","Price","PriceEditable","Catalog_Id","Name","OrderId","Flags",
//   "ShowDescriptionTooltip","HideFromKitchenVisualizer","ImageKey","ImageDescriptionKey","FlatIconImageKey",
//   "RawName","GroupName","IsPlaceholder","FeatureName","HideFromShopingCartOnKV","Unit","Description","Enabled",
//   "MetaData"

// const pricingFeatureInterface = {
//   baseQuantity: PropTypes.number, // 0
//   comparisonFor: PropTypes.string, // "material"
//   comparisonType: PropTypes.string, // "gte"
//   cost: PropTypes.number, // 1
//   costplus: PropTypes.number, // 1
//   defaultQuantity: PropTypes.number, // 1
//   displayName: PropTypes.string, // "Countertop Support Bracket"
//   employeesOnly: PropTypes.bool,
//   fabricatorBaseQuantity: PropTypes.number, // 0
//   fabricatorComparisonFor: PropTypes.string, // "material"
//   fabricatorComparisonType: PropTypes.string, // "gte"
//   fabricatorCost: PropTypes.number, // 1.25
//   fabricatorCostplus: PropTypes.number, // 1.25
//   fabricatorFeatureIds: PropTypes.arrayOf(PropTypes.number), // !! [149793864]
//   fabricatorMaxQuantity: PropTypes.number, // 0
//   fd_Description: PropTypes.string, // "Attachment - 7018018White 0 0 31 imported from KVManager"
//   fd_Enabled: PropTypes.bool,
//   fd_MetaData: PropTypes.string, // "{\"RoomLayout\":[\"1\"],\"MatchingFeature\":[\"7018018\"],\"Filters\":null}"
//   fd_Unit: PropTypes.string, // "Each"
//   featureDefinition_id: PropTypes.number, // !! 1533825
//   ff_Enabled: PropTypes.bool,
//   ff_HideFromShopingCartOnKV: PropTypes.bool,
//   flags: PropTypes.string,
//   galleryEnabled: PropTypes.bool,
//   groupName: PropTypes.string, // "Attachment"
//   hideFromKitchenVisualizer: PropTypes.bool,
//   hideQuantity: PropTypes.bool,
//   hideUnitLabel: PropTypes.bool,
//   imageKey: PropTypes.string, // "env_QKBStaging_f27bf694-9df0-4253-9e2c-5025d4d54103"
//   isBundle: PropTypes.bool,
//   maxQuantity: PropTypes.number, // 0
//   model: PropTypes.string, // ""
//   notTaxable: PropTypes.bool,
//   orderId: PropTypes.number,
//   productNotForSale: PropTypes.bool,
//   showCostInFrontEnd: PropTypes.bool,
//   showDescriptionTooltip: PropTypes.bool,
//   price: PropTypes.number,
//   sku: PropTypes.string, // "CTB"
//   staticName: PropTypes.string, // "Cutting Board"
//   subDescription: PropTypes.string, // "Need minimum 2 brackets\nadd one every 24 in."
//   unlocked: PropTypes.bool,
//   useStonePricing: PropTypes.bool,
// }
